import React from "react";
import "../../src/App.css";

function Documentation() {
  return (
    <div className="page-content">
      <h1>Documentation</h1>
      <p>
        <strong>Last Updated:</strong> May 13, 2025
      </p>
      <p>
        Welcome to the multido.com documentation! This guide will help you get
        started with the app and make the most of its features.
      </p>
      <h2>1. Getting Started</h2>
      <p>
        multido.com is a task management app designed to help you organize your
        tasks and to-do lists efficiently.
      </p>
      <h3>1.1 Creating a Task</h3>
      <p>
        - Click the "Add Main Task" button to create a new task.
        <br />
        - Use the bulk task input to add multiple tasks at once by entering
        comma-separated task names and pressing Enter.
        <br />- Click the "Add Deadline Task" button to create a task with a
        deadline.
      </p>
      <h3>1.2 Setting a Deadline</h3>
      <p>
        - For any task, click the calendar icon in the task controls.
        <br />
        - Select a date from the date picker to set a deadline.
        <br />- The task will display a countdown in days and hours until the
        deadline.
      </p>
      <h2>2. Managing Tasks</h2>
      <h3>2.1 Task Hierarchy</h3>
      <p>
        - Use the "Branch" icon to add subtasks to a task.
        <br />- Navigate through task hierarchies by clicking on tasks with
        children to view their subtasks in a new column.
      </p>
      <h3>2.2 Timer and Completion</h3>
      <p>
        - Start a task’s timer using the play button.
        <br />
        - Pause or reset the timer as needed.
        <br />- Enable "Mark task complete when timer runs out" in the settings
        to auto-complete tasks when the timer finishes.
      </p>
      <h2>3. To-Do Lists</h2>
      <p>
        - Switch to the "To-Do Lists" tab to create general to-do lists or book
        lists.
        <br />- Add a book list to track books with title, author last name, and
        first name.
      </p>
      <h2>4. Settings</h2>
      <p>
        - Open the drawer by clicking the gear icon.
        <br />
        - Toggle features like tags, notes, and auto-completion.
        <br />
        - Set the default task duration using the dropdown.
        <br />
        - Use "Save All" to export your data as a JSON file.
        <br />
        - Use "Import Data" to restore your data from a JSON file.
        <br />- Use "Wipe All" to delete all data (you can save first from the
        modal).
      </p>
      <h2>5. Support</h2>
      <p>
        For additional help, visit our <a href="/faq">FAQ</a> or contact us at{" "}
        <a href="mailto:support@multido.com">support@multido.com</a>.
      </p>
    </div>
  );
}

export default Documentation;
